// extracted by mini-css-extract-plugin
export default {"container":"cards-table-view_container__YY8WI"};